module.exports = __webpack_public_path__ + "static/img/reward-6.513b65a6.png";